import { useState } from 'react';
import { Form, Table } from 'react-bootstrap';

function DependentsAddress({ id, counties }) {

    const [showDependentAddress, setshowDependentAddress] = useState(false);

    const handleDependentAddress = (e) => {
        // toggle dependent address
        if (e.target.checked) {
            setshowDependentAddress(true);
        } else {
            setshowDependentAddress(false);
        }
    }

    return (
        <Table>
            <tbody>
                {showDependentAddress && (
                    <><tr className="noBorder">
                        <td colSpan={2}>
                            <Form.Group controlId={`applicant_Dependent_Address_${id}`}>
                                <Form.Control className='mb-2' placeholder="Street *" type="text" required />
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group controlId={`applicant_Dependent_Apartment_${id}`}>
                                <Form.Control type="text" placeholder="Apartment" className='mb-2' />
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group controlId={`applicant_Dependent_City_${id}`}>
                                <Form.Control type="text" placeholder="City *" className='mb-2' required />
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group controlId={`applicant_Dependent_County_${id}`}>
                                <Form.Select className='mb-2' required>
                                    <option hidden value="">County</option>
                                    {counties?.map((option) => <option value={option} key={option}>{option}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group controlId={`applicant_Dependent_State_${id}`}>
                                <Form.Control type="text" placeholder="State *" className='mb-2' required />
                            </Form.Group>
                        </td>
                        <td>
                            <Form.Group controlId={`applicant_Dependent_Zip_${id}`}>
                                <Form.Control type="number" placeholder="Zip *" className='mb-2' required />
                            </Form.Group>
                        </td>
                        <td></td>
                    </tr>
                        <tr className="noBorder">
                            <td><Form.Group controlId={`applicant_Dependent_Phone_${id}`}>
                                <Form.Control type="tel" placeholder="Phone" className='mb-2' />
                            </Form.Group></td>
                            <td colSpan={7}></td>
                        </tr></>)}
                <tr className="noBorder">
                    <td colSpan={8}>
                        <Form.Check className="col-12"
                            type="checkbox"
                            id={`dependentAddress_${id}`}
                            value={id}
                            onChange={(event) => handleDependentAddress(event)}
                            label="Mailing address, if different than applicants" />
                    </td>
                </tr>
            </tbody>
        </Table>
    )
}

export default DependentsAddress
